import { makeStyles } from "e100-react-components";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    marginLeft: spacing(-2),
    width: `calc(100% + ${spacing(4)}px)`,
    borderRadius: 0,
    fontWeight: 700,
    fontSize: 13,
    "&:hover": {
      backgroundColor: palette.background.default,
    },
  },
  buttonNavigateLabel: {
    display: "flex",
    justifyContent: "space-between",
    color: palette.primary.main,
    fill: palette.secondary.main,
  },
}));
